import * as React from 'react';
class Checkout {
    static register = {
        CKOT_PAYMENT_METHOD_BOX: {slug: 'CKOT_PAYMENT_METHOD_BOX'},
        CKOT_ORDER_PLACED_BOX: {slug:'CKOT_ORDER_PLACED_BOX'},
        CKOT_VIEW:{slug:'CKOT_VIEW',render:<></>}
    };
    static register_external = {
        CKOT_VIEW:{slug:'CKOT_VIEW',render:<></>},
        CKOT_ORDER_PLACED_BOX: {slug:'CKOT_ORDER_PLACED_BOX',render:<></>},
    };
    static register_internal = {
        CKOT_VIEW:{slug:'CKOT_VIEW',render:<></>},
        CKOT_ORDER_PLACED_BOX:{slug:'CKOT_ORDER_PLACED_BOX',render:<></>},
        CHECKOUT_PLACE_ORDER_BUTTON: {slug: 'CHECKOUT_PLACE_ORDER_BUTTON',render:<></>},
        // CKOT_ORDER_PLACED_MESSAGE:{slug:'CKOT_ORDER_PLACED_MESSAGE',render:<></>}
    };
}

export default Checkout;